var _path, _path2, _path3, _rect, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadImages(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5264 69.4935L53.7149 54.6009C53.9175 54.4514 54.2 54.4764 54.3739 54.6592L64.4425 65.243M33.5264 69.4935L36.9817 29.5706C37.0055 29.2955 37.2478 29.0922 37.5228 29.1165L89.9662 33.7545C90.2413 33.7788 90.445 34.0216 90.4212 34.2967L87.2574 70.8512M33.5264 69.4935L32.9864 75.7322C32.9626 76.0073 33.1663 76.25 33.4414 76.2744L85.8848 80.9124C86.1598 80.9367 86.4021 80.7334 86.4259 80.4583L87.5295 67.7075C87.5419 67.5646 87.4923 67.4231 87.3933 67.3191L73.751 52.9787C73.5771 52.7959 73.2946 52.7709 73.092 52.9204L61.1207 61.7513",
    stroke: "#326BFF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7078 69.3597L53.715 54.6009C53.9176 54.4514 54.2001 54.4764 54.374 54.6592L61.1208 61.7513L73.092 52.9204C73.2947 52.7709 73.5772 52.7959 73.7511 52.9787L87.3933 67.3191C87.4923 67.4231 87.5419 67.5646 87.5296 67.7075L86.426 80.4583C86.4022 80.7334 86.1599 80.9367 85.8848 80.9124L33.4414 76.2744C33.1663 76.25 32.9627 76.0073 32.9865 75.7322L33.507 69.7183C33.5193 69.5754 33.5925 69.4447 33.7078 69.3597Z",
    fill: "#326BFF",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5326 46.7213C50.2527 46.9619 52.6512 44.9227 52.8898 42.1667C53.1283 39.4106 51.1165 36.9814 48.3964 36.7408C45.6762 36.5003 43.2777 38.5394 43.0392 41.2955C42.8006 44.0515 44.8124 46.4808 47.5326 46.7213Z",
    fill: "#326BFF",
    fillOpacity: 0.2,
    stroke: "#326BFF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.454943,
    y: 0.542185,
    width: 68.3832,
    height: 69.1247,
    rx: 0.5,
    transform: "matrix(0.996112 0.0880943 -0.086227 0.996276 29.935 20.9862)",
    stroke: "#326BFF",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3524 9.07654L76.7728 25.5018L30.8219 21.5486C30.6896 21.5372 30.558 21.5791 30.4563 21.6649C30.3545 21.7506 30.291 21.8733 30.2797 22.0058L24.8628 85.4835L16.5741 86.6007C16.3018 86.6374 16.0516 86.4474 16.0138 86.1753L6.63274 18.7013C6.59471 18.4278 6.78551 18.1746 7.05891 18.1358L73.7891 8.65567C74.0609 8.61706 74.3124 8.80493 74.3524 9.07654Z",
    fill: "#326BFF",
    fillOpacity: 0.4,
    stroke: "#326BFF",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImages);
export default __webpack_public_path__ + "static/media/UploadImages.812679109af3baf612ea0d0e594beb29.svg";
export { ForwardRef as ReactComponent };